import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';

import { LeadsNewRoutingModule } from './leads-new-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { ArchwizardModule } from 'angular-archwizard';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddOutsourceleadComponent } from './add-outsourcelead/add-outsourcelead.component';
import { MatMenuModule } from '@angular/material/menu';
import { NgxSpinnerModule } from 'ngx-spinner';
import { OutsourceViewComponent } from './outsource-view/outsource-view.component';
import { AllLeadsReportsComponent } from './all-leads-reports/all-leads-reports.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LeadActionComponent } from './lead-action/lead-action.component';
import { DragulaModule } from 'ng2-dragula';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
    AddOutsourceleadComponent,
    OutsourceViewComponent,
    AllLeadsReportsComponent,
    LeadActionComponent
  ],
  imports: [
    CommonModule,
    LeadsNewRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxDatatableModule,
    NgbModule,
    PipeModule,
    ArchwizardModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    NgxSpinnerModule,
    NgApexchartsModule,
    DragulaModule.forRoot(),

  ]
})
export class LeadsNewModule { }
